import React, { FC } from 'react';

import LogoComponent from '../../../../atoms/Logo';

import styles from './index.module.sass';

interface LogoProps {
  image?: string;
  link: string | null;
  name: string;
}

const Logo: FC<LogoProps> = ({ image, link, name }) => (
  <LogoComponent className={styles.logo} image={image} link={link} name={name} />
);

export default Logo;
